import { CardGroup } from '@ps/sports-ui-component-library';
import React, { memo } from 'react';

import type { MultipleReceiptItem, SingleReceiptItem } from '@swf/core/models/sports/types/betSlip';
import { ExpandablePanel } from '@swf/sports/components';

import ReceiptItem from './components/ReceiptItem/ReceiptItem';

interface Props {
  open: boolean;
  title: React.ReactElement;
  receiptItems: SingleReceiptItem[] | MultipleReceiptItem[];
}

const ReceiptItems: React.FC<Props> = ({ open, title, receiptItems }) => {
  if (!receiptItems.length) {
    return null;
  }

  return (
    <ExpandablePanel openInitially={open} title={title}>
      <CardGroup condensed padded>
        {receiptItems.map((receiptItem) => (
          <ReceiptItem key={receiptItem.id} receiptItem={receiptItem} />
        ))}
      </CardGroup>
    </ExpandablePanel>
  );
};

export default memo(ReceiptItems);
